import React, { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getVesselsDetails } from '@api';
import {
  ArrowBackIcon,
  Breadcrumbs,
  ColorBox,
  Grid,
  Link,
  PageHeader,
  Typography
} from '@esgian/esgianui';
import VesselProfileSection from '@components/Sections/ShipAnalytics/VesselProfile';
import { useQuery } from '@tanstack/react-query';

function VesselProfilePage() {
  const [pageCount, setPageCount] = useState(-1);
  const { imo } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Read the fullscreen flag from the URL
  const isMapFullscreen = searchParams.get('overviewMapFullscreen') === 'true';

  const routeChange = (path) => {
    navigate(path);
  };

  const vesselDetailsQuery = useQuery({
    queryKey: ['vesselDetails', { imos: [imo] }],
    enabled: !!imo,
    placeholderData: {},
    queryFn: ({ signal, queryKey }) => {
      return getVesselsDetails(signal, queryKey[1])
        .then((resp) => resp.vessels[0])
        .catch(() => {
          return {};
        });
    }
  });

  const { data = {}, isFetching } = vesselDetailsQuery;

  return (
    <Grid container spacing={2}>
      {!isMapFullscreen && (
        <>
          <Grid item>
            <ColorBox onClick={() => routeChange(pageCount)}>
              <ArrowBackIcon fontSize="small" />
            </ColorBox>
          </Grid>
          <Grid item>
            <PageHeader
              id="lbl-vessel-profile"
              loading={isFetching}
              title={`${data?.vesselName ?? 'Unknown'}`}
              className="vessel-profile-page-header"
              breadcrumbs={
                <Breadcrumbs aria-label="breadcrumb">
                  <Link
                    underline="hover"
                    color="inherit"
                    id="home-breadcrumb"
                    sx={{ cursor: 'pointer' }}
                    onClick={() => routeChange('/${uriExt}/commercial-analytics')}>
                    Home
                  </Link>
                  <Link
                    sx={{ cursor: 'pointer' }}
                    underline="hover"
                    color="inherit"
                    id="commercial-analytics-breadcrumb"
                    onClick={() => routeChange('/${uriExt}/commercial-analytics')}>
                    Commercial Analytics
                  </Link>
                  <Typography color="primary" id="vessel-profile">
                    Vessel Profile
                  </Typography>
                </Breadcrumbs>
              }
            />
          </Grid>
        </>
      )}
      <Grid item xs={12}>
        <VesselProfileSection vesselName={data.vesselName} imo={imo} setPageCount={setPageCount} />
      </Grid>
    </Grid>
  );
}

VesselProfilePage.propTypes = {};

VesselProfilePage.defaultProps = {};

export default VesselProfilePage;
